// extracted by mini-css-extract-plugin
module.exports = {"fontSizeSmall":"style-module_fontSizeSmall__3BzLEtMzKBZYo_V2BJVezV"};